import React from 'react';
import CreateCertificateModal from '../../../company-profile/components/tabs/contacts/companyCertificate/CreateCertificateModal'
import {useCertificateActions} from '../hooks/useCertificateActions';

/**
 * CertificateModalManager
 * Component that manages create, edit, delete modal actions for certificates.
 * 
 * @param {boolean} isDetailPage - Indicates whether the modal belongs to a detail page.
 * @param {function} onExpose - Callback to expose modal handlers (add, edit, delete) to parent.
 */
const CertificateModalManager = ({ isDetailPage = false, onExpose }) => {
  const {
    modalState,
    setModalState,
    handleAdd,
    handleEdit,
    handleDelete,
    handleSubmit,
    handleDownload
  } = useCertificateActions(isDetailPage);


  React.useEffect(() => {
    if (onExpose) {
      onExpose({
        handleAdd,
        handleEdit,
        handleDelete,
        handleDownload
      });
    }
  }, [onExpose, handleAdd, handleEdit, handleDelete, handleDownload]);

  return (
    <CreateCertificateModal
      actionState={{
        visible: modalState.visible,
        mode: modalState.mode,
        data: modalState.data,
      }}
      setActionState={setModalState}
      onSubmit={handleSubmit}
    />
  );
};

export default CertificateModalManager;
